import { Component, ElementRef, HostBinding, HostListener, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { UserService } from "@core/services/user.service";
import { SessionService } from "@core/services/session.service";
import { User } from "@livechat/shared";
import { ThemeService } from "asksuite-citrus";
import { Subject, takeUntil } from "rxjs";
import { SpectatorService } from "src/app/modules/live-chat/services/spectator.service";

@Component({
  selector: "app-spectator-mode",
  templateUrl: "./spectator-mode.component.html",
  styleUrls: ["./spectator-mode.component.scss"],
})
export class SpectatorModeComponent implements OnInit, OnDestroy {
  protected isSpectating = true;

  protected spectator?: User;
  protected user?: User;
  protected theme = '';
  private readonly destroy$ = new Subject<void>();

  constructor(
    private spectatorService: SpectatorService,
    private userService: UserService,
    private sessionService: SessionService,
    private themeService: ThemeService,
  ) { }

  @HostBinding('style.display')
  get displayStyle() {
    const shouldHide = !(this.isSpectating && this.spectator && this.user);
    return shouldHide ? 'none' : null;
  }

  ngOnInit(): void {
    this.themeService.listenThemeChange().subscribe((theme) => this.theme = theme);

    this.isSpectating = this.spectatorService.isSpectating;

    if (this.isSpectating) {
      this.spectator = this.spectatorService.spectator;
      this.user = this.userService.getCurrentUser();

      if (!this.user) {
        this.sessionService.session$?.pipe(takeUntil(this.destroy$))
          .subscribe((session) => {
            if (session?.user && !this.user) {
              this.user = this.userService.getCurrentUser();
            }
          });
      }
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  protected handleEndSpectatingClick() {
    this.spectatorService.endSpectating();
  }
}
